/** Checkbox id for Shipments advanced search → Special Searches → Held. */
export const HAWB_ADVANCE_SEARCH_HELD_CHECKBOX_ID = 'hawbCbpHeld';

/** Display label for the Held special-search checkbox. */
export const HAWB_ADVANCE_SEARCH_HELD_LABEL = 'Held';

/** Advance-search API payload key for tri-state CBP Held filter (`"true"` | `"false"`). */
export const HAWB_ADVANCE_SEARCH_CBP_HELD_PAYLOAD_KEY = 'cbpHeld';

/** Advance-search API payload key for routed shipments at selected gateway facility. */
export const HAWB_ADVANCE_SEARCH_IS_SHIPMENT_ROUTED_PAYLOAD_KEY =
  'isShipmentRouted';

export const HAWB_ADVANCE_SEARCH_IS_SHIPMENT_ROUTED_LABEL =
  'Is Shipment Routed';

export type AdvanceSearchTriStateValue = '' | 'true' | 'false';

export const ADVANCE_SEARCH_TRI_STATE_EMPTY = '' as const;
export const ADVANCE_SEARCH_TRI_STATE_TRUE = 'true' as const;
export const ADVANCE_SEARCH_TRI_STATE_FALSE = 'false' as const;
